import getTitle from "@/src/util/title";
import Head from "next/head";

interface Props { subtitle?: string };

export default function Title(
    { subtitle }: Props,
): JSX.Element {
    const titleText = getTitle(subtitle);

    return (
        <Head>
            <title>{titleText}</title>
            <meta property="og:title" content={titleText} />
            <meta name="twitter:title" content={titleText} />
        </Head>
    );
}
